export enum LocationType {
    BUS_STOP_CODE = '0',
    LINE_ID = '1',
    DIRECTION_ID = '2',
    GENERAL = '3',
}
